<style>
.ly-components-batchinput .el-dialog__title {
    color:#fff;
}
.ly-components-batchinput .el-dialog__header {
    background-color:#515151;
    padding:10px 20px;
}
.ly-components-batchinput .batchinput-state{
    margin-bottom:10px;
}
.is-error textarea{
    border-color:#ff4949;
}
</style>
<template>
<div class="ly-components-batchinput" :class="{'is-error':isError}">
    <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    size="small">
        <div class="batchinput-state">
            <slot name="statement"></slot>
        </div>
        <el-input @change="onFocus" :rows="10" :placeholder="example" v-model="inputText" type="textarea" ></el-input>
        <template slot='footer'>
        <span  class="dialog-footer">
            <el-button @click="cancel">{{cancelText}}</el-button>
            <el-button type="primary" @click="onConfirm">{{comfirmText}}</el-button>
        </span>
        </template>
    </el-dialog>
</div> 
</template>
<script>
/**
 * 
 * 批量添加组件
 * @author welpher
 * @time 2017-9-14
 * 
 * @param {String} [title  = '标题']  - 标题
 * @param {String} [confirm-text = '添加'] - 主按钮文字
 * @param {String} [cancel-text = '取消'] - 取消按钮文字
 * @param {String} [example] - 输入框例子说明
 * 
 * @param {slot}  [statement] - 批量输入说明文字
 * 
 * @param {Function} [open()] - 批量输入打开方法
 * 
 */
export default {
    name: 'LyBatchInput',
    props: {
        title: {
            type: String,
            default: "标题"
        },
        comfirmText: {
            type: String,
            default: "添 加"
        },
        cancelText:{
            type: String,
            default: "取 消"
        },
        example:String
    },
    data () {
        return {
            dialogVisible: false,
            inputText: "",
            isError: false
        }
    },
    methods: {
        onFocus () {
            this.isError = false;
        },
        open () {
            this.inputText = ""
            this.dialogVisible = true;
        },
        cancel () {
            this.dialogVisible = false;
        },
        onConfirm () {
            let text = this.inputText.replace(" ","");
            if (text.length <= 0) {
                this.isError = true;
            } else {
                this.isError = false;
                this.$emit('confirm', text);
                this.dialogVisible = false;
            }
        }
    }
}
</script>